import React, { useEffect, useState } from 'react';
import './Resume.css';
import {
  FaDownload,
  FaEye,
  FaEnvelope,
  FaGithub,
  FaLinkedin,
  FaTelegram,
  FaTwitter,
} from 'react-icons/fa';
import { ContactMe } from '../types';
import { getContactMe } from '../data/localDataService';

const Resume: React.FC = () => {
  const [contactMe, setContactMe] = useState<ContactMe | null>(null);

  useEffect(() => {
    let active = true;
    getContactMe().then((data) => {
      if (active) setContactMe(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="resume-container">
      <header className="resume-header">
        <h1 className="resume-title">Resume</h1>
        <p className="resume-subtitle">
          AI Lead at Impossible Finance | Agent Infrastructure | Crypto &amp; DeFi Research
        </p>
      </header>

      <div className="resume-actions">
        <a
          href="/Resume_Shivom.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="resume-button view-button"
        >
          <FaEye aria-hidden="true" /> View Resume
        </a>
        <a
          href="/Resume_Shivom.pdf"
          download="Shivom_Sharma_Resume.pdf"
          className="resume-button download-button"
        >
          <FaDownload aria-hidden="true" /> Download PDF
        </a>
      </div>

      <div className="resume-preview">
        <iframe
          src="/Resume_Shivom.pdf"
          title="Shivom Sharma Resume"
          className="pdf-viewer"
          frameBorder={0}
        />
      </div>

      <section className="resume-highlights" aria-labelledby="highlights-heading">
        <h2 id="highlights-heading">Quick Highlights</h2>
        <div className="highlights-grid">
          <article className="highlight-card highlight-card--featured">
            <h3>Experience</h3>
            <p>9+ years in blockchain &amp; cryptocurrency</p>
            <p>Senior roles at Impossible Finance, Lemniscap, Nethermind</p>
          </article>
          <article className="highlight-card">
            <h3>Expertise</h3>
            <p>DeFi Protocol Research</p>
            <p>Tokenomics Design</p>
            <p>Smart Contract Analysis</p>
          </article>
          <article className="highlight-card">
            <h3>Achievements</h3>
            <p>Ranked #4 on DegenScore v1</p>
            <p>Advised 20+ blockchain projects</p>
            <p>Published research on major protocols</p>
          </article>
          <article className="highlight-card">
            <h3>Skills</h3>
            <p>Solidity, Python, SQL</p>
            <p>On-chain Analytics</p>
            <p>MEV Research</p>
          </article>
        </div>
      </section>

      <section className="contact-section" aria-labelledby="contact-heading">
        <h2 id="contact-heading">Get in Touch</h2>
        {contactMe === null ? (
          <p className="contact-loading" aria-busy="true" aria-live="polite">
            Loading contact details&hellip;
          </p>
        ) : (
          <>
            <div className="social-links">
              <a
                href={contactMe.linkedinLink}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaLinkedin aria-hidden="true" /> LinkedIn
              </a>
              <a
                href={`mailto:${contactMe.email}`}
                className="social-link"
              >
                <FaEnvelope aria-hidden="true" /> Email
              </a>
              <a
                href="https://github.com/sheeki03"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaGithub aria-hidden="true" /> GitHub
              </a>
              <a
                href="https://x.com/sheeki03"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaTwitter aria-hidden="true" /> Twitter
              </a>
              <a
                href="https://t.me/sheeki03"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaTelegram aria-hidden="true" /> Telegram
              </a>
            </div>
            <a className="email-contact" href={`mailto:${contactMe.email}`}>
              {contactMe.email}
            </a>
          </>
        )}
      </section>
    </div>
  );
};

export default Resume;
